module.exports = __webpack_public_path__ + "static/media/ipad.f65259de.png";